import { render, staticRenderFns } from "./valoraciones.vue?vue&type=template&id=23f9d6da&scoped=true"
import script from "./valoraciones.vue?vue&type=script&lang=js"
export * from "./valoraciones.vue?vue&type=script&lang=js"
import style0 from "./valoraciones.vue?vue&type=style&index=0&id=23f9d6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9d6da",
  null
  
)

export default component.exports